import React from 'react';
import { Box, InputAdornment } from '@mui/material';
import { FormProvider } from 'react-hook-form';
import { RHFTextField } from '../RHF';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import CustomDialog from '../Dialog/Dialog';
import { CustomButton } from 'components/Button';
import logoImage from '../../assets/images/logo.svg';
import userImage from '../../assets/images/user.svg';
import callIconImage from '../../assets/images/callIcon.svg';
import emailImage from '../../assets/images/email.svg';
import businessImage from '../../assets/images/store_icon.svg';

interface EnterpriseContactFormProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: EnterpriseContactFormData) => void;
  isPending: boolean;
  isRetrying?: boolean;
}

interface EnterpriseContactFormData {
  company_name: string;
  contact_name: string;
  contact_email: string;
  phone_number: string;
}

const validationSchema = yup.object({
  company_name: yup.string().required('Company name is required'),
  contact_name: yup.string().required('Contact name is required'),
  contact_email: yup.string().email('Invalid email').required('Email is required'),
  phone_number: yup.string().required('Phone number is required'),
});

const EnterpriseContactForm: React.FC<EnterpriseContactFormProps> = ({
  open,
  onClose,
  onSubmit,
  isPending,
  isRetrying = false,
}) => {
  const formMethods = useForm<EnterpriseContactFormData>({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      company_name: '',
      contact_name: '',
      contact_email: '',
      phone_number: '',
    },
  });

  const handleSubmit = (data: EnterpriseContactFormData) => {
    console.log('🔍 Enterprise Contact Form Submit:', data);
    onSubmit(data);
  };

  return (
    <CustomDialog
      open={open}
      handleClose={onClose}
      isHeader={false}
      width="486px"
      fullWidth={true}
    >
      <FormProvider {...formMethods}>
        <form onSubmit={formMethods.handleSubmit(handleSubmit)}>
          <Box className={"auth-form-container"}>
            <img src={logoImage} alt="logo" className="auth-form-logo d-block" />

            <p className="divider" />

            <p className="auth-form-title">Enterprise Contact</p>
            <p className="auth-form-text">
              Get in touch with our enterprise team. We'll discuss your multi-store lottery management needs and provide a customized solution.
            </p>

            <Box className={"textfieldCont"}>
              <RHFTextField
                name="company_name"
                placeholder="Company Name"
                slotProps={{
                  input: {
                    startAdornment: <InputAdornment position="start"><img src={businessImage} alt="business" /></InputAdornment>,
                  },
                }}
              />
            </Box>

            <Box className={"textfieldCont"}>
              <RHFTextField
                name="contact_name"
                placeholder="Your Name"
                slotProps={{
                  input: {
                    startAdornment: <InputAdornment position="start"><img src={userImage} alt="user" /></InputAdornment>,
                  },
                }}
              />
            </Box>

            <Box className={"textfieldCont"}>
              <RHFTextField
                name="contact_email"
                placeholder="Email Address"
                slotProps={{
                  input: {
                    startAdornment: <InputAdornment position="start"><img src={emailImage} alt="email" /></InputAdornment>,
                  },
                }}
              />
            </Box>

            <Box className={"textfieldCont"}>
              <RHFTextField
                name="phone_number"
                placeholder="Phone Number"
                slotProps={{
                  input: {
                    startAdornment: <InputAdornment position="start"><img src={callIconImage} alt="phone" /></InputAdornment>,
                  },
                }}
              />
            </Box>

            <Box>
              <CustomButton
                type="submit"
                loading={isPending}
                disabled={isPending}
                className="button-base button-compact auth-form-button"
              >
                {isRetrying ? 'Retrying...' : isPending ? 'Sending...' : 'Contact Sales Team'}
              </CustomButton>
            </Box>
          </Box>
        </form>
      </FormProvider>
    </CustomDialog>
  );
};

export default EnterpriseContactForm;
